import { type SyncApp } from '../../server/sync';
import {
  processesPullOutput,
  processesPushOutput,
  type ProcessesPushRow,
} from '../../shared/sync/processes';
import { type Checkpoint, syncErrorSchema } from '../../shared/sync/schemas';
import { hc } from 'hono/client';

const client = hc<SyncApp>('/api/sync', {
  fetch: (input: RequestInfo | URL, init?: RequestInit) =>
    fetch(input, { ...init, credentials: 'include' }),
});

type FetchLike = { json: () => Promise<unknown>; ok: boolean; status: number };

const throwSyncError = async (res: FetchLike): Promise<never> => {
  let body: unknown;
  try {
    body = await res.json();
  } catch {
    throw new Error(`sync ${res.status}`);
  }

  const parsed = syncErrorSchema.safeParse(body);
  const code = parsed.success ? parsed.data.code : 'BAD_REQUEST';
  const message = parsed.success ? parsed.data.message : `sync ${res.status}`;
  throw new Error(`[${code}] ${message}`);
};

export const pullProcesses = async (input: {
  batchSize: number;
  checkpoint: Checkpoint | null;
}) => {
  const res = await client.v1.processes.pull.$post({
    json: {
      batchSize: input.batchSize,
      checkpoint: input.checkpoint,
    },
  });
  if (!res.ok) {
    await throwSyncError(res);
  }

  return processesPullOutput.parse(await res.json());
};

export const pushProcesses = async (rows: ProcessesPushRow[]) => {
  const res = await client.v1.processes.push.$post({ json: { rows } });
  if (!res.ok) {
    await throwSyncError(res);
  }

  return processesPushOutput.parse(await res.json());
};
